var faqData = {
  Master: {
    nav: [
      `pre-Sale Questions`,
      `Quick Start`,
      `Maintenance`,
      `Issues and Troubleshooting`,
    ],
    nav_desc: [
      `What You Need to Know Before Buying`,
      `Your First Steps Made Simple (For Beginners)`,
      `Keep Your Machine in Top Shape`,
      `Find Fixes for Common Problems`,
    ],
    quantions: [
      // Category 1: Part 3
      [
        {
          Q: `Can Master cut transparent acrylic? What thickness can it cut?`,
          A: `Yes, it can cut acrylic up to 12 mm thick.`,
          video_url: [],
        },
        {
          Q: `What is the engraving area of Master?`,
          A: `In CO₂ mode, the working area is 500 mm × 300 mm. In IR mode (sold separately), the working area is 300 mm × 265 mm.`,
          video_url: [],
        },
        {
          Q: `What is the laser power of Master?`,
          A: `The CO₂ laser power is 50W, and the IR laser power is 1.6W (sold separately).`,
          video_url: [],
        },
        {
          Q: `Can Master engrave metal?`,
          A: `Yes. A dedicated 1.6W Master IR laser module (sold separately) can be purchased to engrave most metal materials.`,
          video_url: [],
        },
        {
          Q: `Does Master support expandable laser modules?`,
          A: `Yes. A dedicated 1.6W Master IR laser module can be purchased separately.`,
          video_url: [],
        },
        {
          Q: `How does Master perform auto focus when processing soft materials?`,
          A: `If the material is very thin, place a hard wooden board or cutting mat underneath the material. If the material is relatively thick, manual focus is recommended.`,
          video_url: [],
        },
        {
          Q: `Is Master compatible with standard power voltages?`,
          A: `The machine is currently available in two versions: 220V and 110V. Please choose the appropriate version according to your local mains voltage.`,
          video_url: [],
        },
        {
          Q: `Can Master operate offline?`,
          A: `Yes. Copy \`.nc\` or \`.gc\` files to a USB drive, then insert the USB drive into the machine for automatic recognition. It is recommended to place the files in the root directory of the USB drive.`,
          video_url: [],
        },
        {
          Q: `Can Master cut transparent glass?`,
          A: `No, it cannot cut transparent glass, as this may cause the glass to crack or shatter. However, it can engrave transparent glass.<br/>
Note: Transparent acrylic can be cut.`,
          video_url: [],
        },
        {
          Q: `What is the maximum material thickness Master can engrave?`,
          A: `The maximum material thickness that can fit inside the enclosure for engraving is 60 mm.`,
          video_url: [],
        },
        {
          Q: `Can Master expand its working area with additional accessories?`,
          A: `Yes. You can purchase the Z1 riser and the R7 conveyor feeder to expand the working area to 500 mm × 800 mm. In IR mode, the working area can be expanded to 300 mm × 800 mm.`,
          video_url: [],
        },
        {
          Q: `What purifier is recommended for Master? What hose size is supported?`,
          A: `The D4 purifier is recommended. It supports hoses with a diameter of 75 mm.`,
          video_url: [],
        },
        {
          Q: `What is the fan speed of Master enclosure? Can it effectively remove smoke from inside the enclosure?`,
          A: `The fan speed is 7000 RPM. It can effectively remove smoke and fumes from inside the enclosure.`,
          video_url: [],
        },
        {
          Q: `What is the enclosure protection rating of Master? Can it effectively isolate harmful gases and fumes?`,
          A: `The machine is certified as a Class 1 laser product. When the enclosure door is closed, it can effectively reduce smoke leakage; however, it is still recommended to connect an exhaust or air purification system.`,
          video_url: [],
        },
        {
          Q: `What are the requirements for Master cooling water? How often should it be replaced?`,
          A: `Distilled water, purified water, or high-purity water that meets the required specifications must be used. Replacement every 30 days is recommended.`,
          video_url: [],
        },
        {
          Q: `What is the recommended operating environment temperature for Master?`,
          A: `The recommended operating temperature range is 5°C to 35°C.<br/>
* When the temperature is below 5°C, add antifreeze to the water tank. Please refer to the “Water Tank Refill and Water Replacement Guide of Master” section.<br/>
* When the temperature reaches 35°C, turn on air conditioning to reduce the indoor temperature.<br/>
Note:<br/>
* When the water temperature is below 5°C or above 35°C, the machine will trigger a water temperature warning alarm.<br/>
* When the water temperature is below 0°C or above 40°C, the machine will trigger an alarm and automatically stop operating.<br/>
* The real-time temperature will be displayed on both the main screen interface and the AtomStack Studio software interface.<br/>
* If the machine fails to automatically trigger the alarm or stop operation, please manually power off the machine immediately.`,
          video_url: [],
        },
        {
          Q: `Can Master operate in low-temperature environments?`,
          A: `When the temperature is below 5°C, add antifreeze to the water tank. Please refer to the “Master Water Tank Refill and Water Replacement Guide” section.<br/>
When the temperature exceeds 35°C, turn on air conditioning to lower the indoor temperature.<br/>
After adding antifreeze, the machine can operate normally as long as the liquid in the water tank does not freeze.`,
          video_url: [],
        },
        {
          Q: `Can Master engrave and cut leather?`,
          A: `Yes.<br/>
* For bitmap engraving and fill engraving, you can try using 25,000 mm/min at 50% power.<br/>
* For vector engraving, use 5,000 mm/min at 30% power.<br/>
* For cutting 3 mm thick leather, the recommended settings are 150 mm/min at 100% power.`,
          video_url: [],
        },
        {
          Q: `Can Master be controlled using a mobile app?`,
          A: `Yes. Download the AtomStack App to connect and operate the machine.`,
          video_url: [],
        },
        {
          Q: `Can Master engrave tumblers or stainless steel bottles?`,
          A: `Yes. Additional accessories are required, such as the R6 or R8 rotary attachment. Please refer to the “Using the Master Rotary Attachments” section.`,
          video_url: [],
        },
        {
          Q: `What control software can be used with Master?`,
          A: `AtomStack Studio is the recommended software. LightBurn and the AtomStack App are also supported.`,
          video_url: [],
        },
        {
          Q: `What is the airflow rate of Master air assist system?`,
          A: `The airflow rate is ≥23 L/min. When cutting thicker materials, it is recommended to connect an external air pump with stronger airflow (≥40 L/min).`,
          video_url: [],
        },
        {
          Q: `If Master accessories are damaged, can they be replaced individually? Is replacement easy?`,
          A: `Yes. The machine features a modular design, so if a component is damaged, only the damaged part needs to be replaced.`,
          video_url: [],
        },
        {
          Q: `What is the Z-axis travel distance of Master?`,
          A: `56 mm.`,
          video_url: [],
        },
        {
          Q: `When using the R7 conveyor feeder with Master, how much clearance should be left from the wall?`,
          A: `At least 510 mm of clearance from the wall is required to prevent the R7 conveyor feeder from hitting the wall.`,
          video_url: [],
        },
        {
          Q: `What is the lifespan of Master laser tube?`,
          A: `The lifespan is approximately 10,000 hours. During operation, cooling water must be added to the water tank and maintained above the marked minimum water level.`,
          video_url: [],
        },
        {
          Q: `How should debris be cleaned after cutting with Master?`,
          A: `The Master is designed with a bottom tray. To clean debris, first remove debris from the inner frame of the enclosure, then pull out the tray and clean it thoroughly.`,
          video_url: [],
        },
        {
          Q: `How often should Master be cleaned and maintained?`,
          A: `Different components require different cleaning frequencies. Please refer to the “Maintenance and Care” section for details.`,
          video_url: [],
        },
        {
          Q: `Is it necessary to purchase protective goggles for Master?`,
          A: `Master uses a fully enclosed design, and the enclosure door is made of transparent acrylic material with filtering properties. Under proper operating conditions, protective goggles are not required.`,
          video_url: [],
        },
        {
          Q: `What precautions should be taken when transporting Master?`,
          A: `<br/>
(1). Before transportation, completely drain the water tank. Please refer to the “Water Tank Refill and Water Replacement Guide of Master” section for the draining procedure.<br/>
(2). During transportation, keep the machine upright and repack it in the original packaging to avoid damage.`,
          video_url: [],
        },
        {
          Q: `Can Master engrave reflective materials?`,
          A: `Reflective materials should not be engraved directly. Before engraving, cover the surface with black marker ink or apply colored paper over the surface. This helps prevent laser reflections that could cause accidents or damage to the laser system.`,
          video_url: [],
        },
        {
          Q: `What materials are prohibited from being processed with Master?`,
          A: `The following materials must not be processed:<br/>
* PVC (releases chlorine gas)<br/>
* Chlorine-containing plastics<br/>
* Metals with unknown coatings<br/>
* Highly reflective mirror-like materials (may reflect the laser and damage the laser system)<br/>
Note: When processing unknown materials, it is recommended to perform a low-power test first.`,
          video_url: [],
        },
        {
          Q: `What precautions should be taken during long periods of operation?`,
          A: `During extended operation, it is recommended to stop the machine for 5–10 minutes after every 2 hours of use to allow the cooling system to return to optimal condition.`,
          video_url: [],
        },
        {
          Q: `What precautions should be taken when storing Master for a long time without use?`,
          A: `<br/>
* If the machine will not be used for an extended period, drain the cooling water from the tank according to the “Master Water Tank Refill and Water Replacement Guide” tutorial to prevent internal moisture buildup or other unexpected issues.<br/>
* Store the machine in a dry environment. Avoid leaving the machine in humid conditions for long periods, and power on the machine periodically. It is recommended to run the fan for 10 minutes once per week to help prevent bearing corrosion.`,
          video_url: [],
        },
      ],
      // Category 2: Part 1
      [
        {
          Q: `Master Control Panel Overview`,
          A: `[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-image01.png?v=1785393965:image1.png]<br/>
(1) Control Panel: <br/>
Enables offline operation, directional movement, auto focus, switching between IR/CO₂laser sources, function settings, movement mode settings, ignition, Bluetooth monitoring, and more.<br/>
(2) Tray: <br/>
Convenient for cleaning debris and protecting the work surface.<br/>
(3) USB Drive Port: <br/>
Slot for inserting a USB flash drive.<br/>
(4) USB Key Port: <br/>
The machine operates only when the USB key is inserted (pre-installed at the factory). Without the USB key, the machine cannot emit laser.<br/>
(5) Computer Port: <br/>
Used to connect to a computer via a Type-C cable.<br/>
(6) Expansion Port: <br/>
Used to connect rotary devices or conveyor feeders. Features automatic recognition and supports connection to R6, R8, and R7.<br/>
(7) Emergency Stop Switch: <br/>
In an emergency, press this switch to cut off power and stop operation, ensuring personal and equipment safety. After pressing, rotate clockwise to release and restore power supply.<br/>
(8) Exhaust Fan: <br/>
Removes smoke and dust from the enclosure. Can be connected to an external exhaust hose (e.g., connected to an AtomStack D4 purifier or vented outdoors).<br/>
(9) Power Switch: <br/>
Turns the machine on or off.<br/>
(10) Power Socket: <br/>
AC power input. Ensure the machine is compatible with the local voltage before connecting (Master supports two voltage options: 220V and 110V).<br/>
(11) Drain Outlet: <br/>
Unscrew the cap to drain the coolant from the water tank.<br/>
(12) Air Pump Interface: <br/>
Allows connection of external air assist. When cutting thicker materials, it is recommended to use external air assist to increase airflow (note: airflow cannot be controlled via the control panel or software when using external air assist).`,
          video_url: [],
        },
        {
          Q: `Safety Instructions for Using Master`,
          A: `(1) Before turning on the machine, please check whether the standard voltage of the engraving machine matches the local mains voltage. Do not connect a machine rated for 110V to a 220V power supply.<br/>
(2) It is strictly prohibited to open the Enclosure door and look directly at the laser while the machine is operating.<br/>
(3) The machine must be attended at all times during the engraving process.<br/>
(4) Processing PVC or chlorine-containing materials is prohibited.<br/>
(5) Please ensure that the exhaust system is functioning properly.`,
          video_url: [],
        },
        {
          Q: `Software and File Formats Supported by Master`,
          A: `Software: AtomStack Studio, LightBurn, and the AtomStack App.<br/>
File formats: SVG, DXF, PNG, JPG, JPEG, WEBP, GIF, etc. In offline working mode, only GC and NC formats are supported.`,
          video_url: [],
        },
        {
          Q: `Master Unboxing Inspection`,
          A: `Please refer to the Master unboxing video.<br/>
Note: Before powering on the machine, carefully check the following items:<br/>
(1) After unpacking the carton, inspect the exterior of the machine. If there is any damage, please take clear photos and send them to customer service for assistance.<br/>
(2) Before connecting the power, make sure the machine’s power supply matches the local mains voltage. Master is available in two voltage versions: 220V and 110V. Connecting a 110V model to a 220V power supply may damage the internal power supply of the machine.<br/>
(3) Before powering on the machine, remove the fixing screws that secure the X-axis and Z-axis.<br/>
(4) The machine must be placed and operated on a level surface. Tilting, flipping, or inverting the machine is strictly prohibited.<br/>
(5) Make sure the USB key is inserted.<br/>
(6) Before powering on the machine, fill the water tank with suitable distilled water, purified water, or high-purity water. The water level should be between the minimum and maximum level marks, as shown in Figure 1.<br/>
Note: Powering on the machine without adding water to the tank may cause the CO₂ tube to crack.<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_1.png:Figure 1]<br/>
(7) When the ambient temperature is below 5°C, a non-corrosive antifreeze solution must be added to the water tank. The recommended mixing ratio is as follows：<br/>
[table:master_part1_q4_table1]<br/>
(8) Do not open the Enclosure door while the machine is operating, and never look directly at the laser without proper protection.<br/>
(9) The machine must be supervised at all times during operation.`,
          tables: {
            master_part1_q4_table1: {
              headers: [
                `Operating environment temperature`,
                `Antifreeze-to-water ratio`,
              ],
              rows: [
                [`-45℃~-42℃`, `6:4(60% antifreeze and 40% water)`],
                [`-35℃~-32℃`, `5:5 (50% antifreeze and 50% water)`],
                [`-25℃~-22℃`, `4:6 (40% antifreeze and 60% water)`],
                [`-15℃~-12℃`, `3:7 (30% antifreeze and 70% water)`],
                [`-5℃~0℃`, `2:8 (20% antifreeze and 80% water)`],
              ],
            },
          },
          video_url: ['https://youtu.be/4pw3kmlBeA8'],
        },
        {
          Q: `Master Online Connection Setup`,
          A: `Please refer to the Master online operation video.<br/>
Note:<br/>
(1) When using the machine with a computer for the first time, please install the CH340 serial port driver. Download links are as follows:<br/>
* Windows driver download link: [https://asa.atomstack.com/downloadWindowsDrivers.do3](https://asa.atomstack.com/downloadWindowsDrivers.do3)<br/>
* macOS driver download link: [https://asa.atomstack.com/downloadMacDrivers.do3](https://asa.atomstack.com/downloadMacDrivers.do3)<br/>
(2) When using AtomStack Studio, the machine can be connected and used directly without additional settings.<br/>
When using LightBurn, make sure the baud rate is set to 460800 (see Figure 2), and change the Job Origin to the upper-left corner. It is recommended to import the machine configuration file (included on the USB drive provided with the machine). For the import method, please refer to the video or the “06 Tips for Use” section in the manual, under “9. How to Use LightBurn for Engraving and Cutting.”<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_2.png:Figure 2]<br/>
(3) When using AtomStack Studio, no confirmation setup is required.<br/>
When using LightBurn, make sure to add a GRBL controller (see Figure 3) or import the factory configuration file for the Master.<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_3.png:Figure 3]<br/>
(4) For Windows computers, the machine can be connected directly using a Type-C to USB-A or USB-C cable.<br/>
For macOS or HarmonyOS computers, a docking station/hub (see Figure 4) is required to connect the USB-A end of the Type-C cable.<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_4.png:Figure 4]`,
          video_url: ['https://youtu.be/m9sWh1IehzY'],
        },
        {
          Q: `Introduction to the Master Control Screen Functions`,
          A: `Please refer to the Master control screen function introduction video.<br/>
Note:<br/>
(1) Main Interface: Start/Pause button, Stop button, Frame button, Laser Test button, Auto Focus button, Laser Source Switch button, Temperature Display, X/Y/Z Axis Movement buttons, Reset button, Processing Mode, Network Status, A-axis Movement button, Repeat Engraving, etc. (see Figure 5).<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_5.png:Figure 5]<br/>
* Start/Pause button: Start or pause offline processing tasks stored on the USB drive.<br/>
Note: Only .nc or .gc files are supported.<br/>
* Stop button: Immediately terminate the current processing task.<br/>
* Frame button: Move along the boundary of the processing pattern to display the engraving/cutting area.<br/>
* Laser Test button: Briefly emit the laser for positioning or testing purposes.<br/>
* Auto Focus button: Start the auto-focus function.<br/>
* Laser Source Switch button: Switch between CO₂ mode and IR mode.<br/>
* Temperature Display: Displays the current operating temperature of the machine.<br/>
* X/Y/Z Axis Movement buttons: Control movement along the X, Y, and Z axes.<br/>
* Reset button: Perform homing/reset operation.<br/>
* Processing Mode: Displays the current operating mode of the machine.<br/>
* Network Status: Displays the current network connection status of the machine.<br/>
* A-axis Movement button: Controls the movement of expansion accessories such as rotary attachments or conveyor systems.<br/>
* Repeat Engraving: Repeat the most recent processing task.<br/>
(2) Function Interface: Jog Mode, Single-shot Mode, Bluetooth Information, Wi-Fi, Machine Configuration, Language, System Information, System Reset, Laser Source Switching, and Focus Settings (see Figure 6).<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_6.png:Figure 6]<br/>
* Jog Mode: Allows you to set the control method for the movement buttons. When “Jog” mode is selected, the machine moves one step each time the movement button is pressed. When “Continuous” mode is selected, the machine will continue moving while the button is held down. This interface also allows you to set the movement distance and speed for each operation.<br/>
* Single-shot Mode: Allows you to set the pulse duration and pulse power.<br/>
* Bluetooth: Displays the machine’s Bluetooth information and allows switching directly to Bluetooth mode.<br/>
* Wi-Fi: Allows you to connect to Wi-Fi and view the machine’s IP address.<br/>
* Machine Configuration: Allows you to configure machine functions, such as enabling or disabling the air pump, flame detector, interlock switch, and adjusting the lighting brightness.<br/>
* Language: Allows you to select the machine language.<br/>
* System Information: Displays the machine’s hardware information.<br/>
* System Reset: Restores the machine to factory settings.<br/>
* Laser Source Switching: Allows switching between IR mode and CO₂ mode.<br/>
* Focus Settings: Allows you to choose between auto focus and manual focus, and set the movement distance for each adjustment in manual focus mode.<br/>
(3) Files: Allows you to view and delete saved files.<br/>
(4) Restart: Click to restart the machine.`,
          video_url: ['https://youtu.be/q0dPmUvqBgo'],
        },
        {
          Q: `Focus Adjustment of Master`,
          A: `Please refer to the focus adjustment video of Master.<br/>
Note:<br/>
(1) When using auto focus, the distance between the bottom of the Z-axis assembly and the top surface of the material should be 8 mm.<br/>
(2) When using a rotary attachment, manual focus is recommended.<br/>
(3) When manual focus is selected, use the directional control buttons on the control screen to adjust the height to 8 mm.<br/>
(4) If the material is very thin or soft, manual focus is recommended.<br/>
(5) If manual focusing is required frequently, it is recommended to use an 8 mm thick board as a height adjustment gauge.<br/>
(6) If an IR laser module is installed, please pay attention to the installation height of the laser head when using the IR laser:<br/>
* First install and secure the laser module, place the material (such as a wooden board), and perform an auto focus operation.<br/>
* After focusing is completed, swing down the fixed-focus rod of the IR laser module (see Figure 7). Loosen the screws securing the IR laser module and allow the fixed-focus rod to touch the top surface of the material.<br/>
* Swing the fixed-focus rod back up, then tighten the screws securing the IR laser module. The focus adjustment is now complete.<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_7.png:Figure 7]`,
          video_url: ['https://youtu.be/XjcIIdfT0YM'],
        },
        {
          Q: `Using the Camera on Master`,
          A: `Please refer to the Master camera operation video.<br/>
Note:<br/>
(1) When using the camera, the Enclosure door must be closed. Ensure that the interior of the machine is well lit, and do not use Wi-Fi connection mode while operating the camera.<br/>
(2) When using the camera, absolute coordinates must be enabled, and the machine must be homed first. Conveyor and rotary attachments cannot be used with the camera function.<br/>
(3) When using the camera with AtomStack Studio, only alignment is required, as the camera has already been calibrated at the factory.<br/>
(4) When using the camera, if the thickness of the engraved objects varies significantly, the camera must be recalibrated after changing the object.<br/>
(5) During camera calibration, make sure a flat sheet of kraft paper is placed and secured on top of the material surface.<br/>
(6) When calibrating the camera using LightBurn, please note the following:<br/>
* Be sure to distinguish between CO₂ mode and IR mode. If an IR laser module is installed, remove both the IR laser module and its mounting bracket before calibrating the CO₂ laser. When using the IR laser module, the camera must be recalibrated. First, switch to the “AtomStack_Master-1064nm_V1.01” device profile in LightBurn (the IR laser module uses a different coordinate system and a working area of 300 mm × 265 mm).<br/>
* Follow the on-screen instructions for calibration and alignment. When selecting the center points of the four markers, you can zoom in on the image before selecting the points to improve accuracy (see Figure 8).<br/>
* During alignment, right-click in the camera view interface and select “Calibrate Camera Alignment”.<br/>
* LightBurn version 1.7.03 or later is recommended for easier operation and higher calibration accuracy.<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_8.png:Figure 8]<br/>
(7) When performing camera calibration, please disable the Air Assist function on the control screen.`,
          video_url: ['https://youtu.be/p4FCNKBpdjA'],
        },
        {
          Q: `Using the Master Conveyor feeder`,
          A: `Please refer to the Master conveyor operation video.<br/>
Note:<br/>
(1) When using the conveyor feeder, it must be used together with the dedicated riser, model Z1.<br/>
(2) When assembling the conveyor feeder, the panel fixing screws must first be removed. For details, please refer to the R7 user manual.<br/>
(3) The R7 conveyor feeder supports automatic detection. Simply connect the USB cable supplied with the R7 (see Figure 9) to the machine’s expansion function port to use it.<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_9.png:Figure 9]<br/>
(4) Absolute coordinates cannot be used when the conveyor system is connected, so the camera function cannot be used simultaneously.<br/>
(5) After connecting the conveyor feeder, the working area changes to 500 mm × 800 mm in CO₂ mode and 300 mm × 800 mm in IR mode.<br/>
(6) When connecting to LightBurn, select “Roller”type in the rotary setup settings, set the rotary axis to the A-axis, and set the diameter to 13 mm (fixed value), as shown in Figure 10.<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_10.png:Figure 10]<br/>
(7) When positioning the conveyor feeder, make sure the USB port is facing the front of the machine.<br/>
(8) When using the R7 conveyor feeder, leave at least 510 mm of clearance between the machine and the wall to prevent the R7 from hitting the wall.`,
          video_url: ['https://youtu.be/ML2LibL4dto'],
        },
        {
          Q: `Using the Rotary Attachments on Master`,
          A: `Please refer to the Master rotary attachment operation video.<br/>
Note:<br/>
(1)Compatible rotary attachment models are R6 and R8. To use them, connect the USB cable supplied with the rotary attachment (see Figure 11) to the machine’s expansion function port.<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_11.png:Figure 11]<br/>
(2) When using AtomStack Studio:<br/>
* The roller rotary attachment (R6) does not require parameter configuration.<br/>
* The chuck rotary attachment (R8) requires the circumference or diameter of the workpiece to be entered (see Figure 12).<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_12.png:Figure 12]<br/>
(3) Absolute coordinates cannot be used when using a rotary attachment, so the camera function cannot be used simultaneously.<br/>
(4) Since the Master machine is relatively heavy, using the Z1 riser is recommended when using rotary attachments.<br/>
(5) When using a rotary attachment, it must be positioned parallel to the X-axis.<br/>
(6) When using a rotary attachment, the motor side of the rotary attachment must face to the right.<br/>
(7) When using the R8 chuck rotary attachment, please note the following:<br/>
* The maximum supported diameter for cylindrical objects is 0 mm–80 mm.<br/>
* The maximum supported diameter for spherical objects is 25 mm–80 mm.<br/>
* The maximum supported diameter for ring-shaped objects is 10 mm–70 mm.<br/>
* The maximum supported workpiece weight is 1.5 kg.<br/>
(8) When using LightBurn, rotary parameters must be configured:<br/>
* Select the rotary type (choose “Roller” for R6 and “Chuck” for R8).<br/>
* Set the rotary axis to the A-axis.<br/>
For parameter settings:<br/>
* For the R8, enter either the diameter or the circumference of the material (see Figure 13).<br/>
* For the R6, set the roller diameter to 16 mm (fixed value), and enter either the diameter or the circumference of the material (see Figure 14).<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_13.png:Figure 13]<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_14.png:Figure 14]`,
          video_url: ['https://youtu.be/MVo6Bd1LbLs'],
        },
        {
          Q: `Coordinate Modes in Software for Controlling the Master`,
          A: `(1) Current Position: Uses the current position of the laser head as the engraving starting point. The laser can be moved to the desired engraving position using the direction keys on the control panel.<br/>
(2) User Origin: Allows the user to define the starting position for laser processing.<br/>
(3) Absolute Coordinates: Uses the home position (0,0) as the reference point, and starts processing based on the coordinates where the workpiece is located.`,
          video_url: [],
        },
        {
          Q: `Optical Path Verification and Calibration of Master`,
          A: `Please refer to the video of Master optical path verification and calibration.<br/>
Note:<br/>
(1) When verifying the optical path, pay attention to the following two points:<br/>
* Beam Spot Verification: Attach a small piece of white paper to the third mirror (Z-axis mirror) to observe the laser spot position. Use the control screen to move the laser module along the four inner edges of the enclosure and observe whether the laser spot position changes. If the position remains nearly unchanged, the optical path is properly aligned. If there is a noticeable shift, the optical path is misaligned and requires adjustment.<br/>
* Beam Alignment Verification: Attach a piece of masking tape or white paper to the focusing lens frame. Press the laser test button on the control screen or in the software and check whether the red guide beam overlaps with the laser beam spot. If they do not overlap, adjust the screws of the beam combiner module located at the front end of the CO₂laser tube until the two spots align (see Figure 15).<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_15.png:Figure 15]<br/>
* Cutting Verification: Cut a large square within the working area. After performing a single cutting pass, check whether all four sides of the square are fully cut through. If the material is completely cut through in one pass and all four sides are evenly cut, the optical path is properly aligned. If some sides are cut through while others are not, the optical path is misaligned and requires adjustment.<br/>
(2)When calibrating the optical path, begin by adjusting the first mirror, then adjust the second mirror, and finally the third mirror (see Figure 16).<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_16.png:Figure 16]<br/>
(3) When adjusting the optical path, observe all safety precautions and do not operate the machine carelessly.<br/>
(4) Before testing after adjustment, remove all adjustment tools to prevent them from being damaged by the laser.`,
          video_url: ['https://youtu.be/L9KRcFxlIy0'],
        },
        {
          Q: `Master IR Laser Module Installation Guide`,
          A: `Please refer to the Master IR laser module installation tutorial video.<br/>
Note: The IR laser module (infrared laser module) is sold separately.<br/>
Note:<br/>
(1) First install the IR laser module bracket. When installing the bracket, make sure it presses against the auto-detection sensor on the Z-axis frame (see Figure 17).<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_17.png:Figure 17]<br/>
(2) After installing the IR laser module, the focus distance must be adjusted:<br/>
* First install and secure the laser module, place a rigid material such as a wooden board, and perform an auto focus operation.<br/>
* After focusing is completed, swing down the fixed-focus rod of the IR laser module (see Figure 18). Loosen the screws securing the IR laser module and allow the fixed-focus rod to touch the material surface.<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_18.png:Figure 18]<br/>
* Swing the fixed-focus rod back up, then tighten the screws securing the IR laser module. The focus adjustment is now complete.<br/>
(3) After switching to IR mode, the working area will change to 300 mm × 265 mm accordingly.<br/>
(4) The IR laser module can engrave most common metals. However, please note that it cannot engrave materials such as gold or wood effectively, or the engraving results may be very poor.`,
          video_url: ['https://youtu.be/-KbyNM6hYt0'],
        },
        {
          Q: `Master Dual-Laser Operation Guide`,
          A: `Please refer to the Master dual-laser operation tutorial video.<br/>
Note:<br/>
(1) The engraving areas for CO₂ mode and IR mode are different:<br/>
* CO₂ mode engraving area: 500 mm × 300 mm<br/>
* IR mode engraving area: 300 mm × 265 mm<br/>
(2) When using AtomStack Studio, different layers within the same project file can be assigned separately to CO₂ mode or IR mode (see Figure 19).<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_19.png:Figure 19]<br/>
(3) After installing the IR laser module, focus calibration must be performed. If the focus distance is inaccurate, the IR laser module will not function properly. Please refer to the “Master Focus Adjustment” section for details.<br/>
(4) AtomStack Studio supports dual-laser mode, but the CO₂ and IR laser systems must first be calibrated. Please refer to the tutorial video for the calibration procedure.`,
          video_url: ['https://youtu.be/cRQg4Z5XTSU'],
        },
        {
          Q: `Master Firmware Update Guide`,
          A: `Please refer to the Master firmware update tutorial video.<br/>
Note:<br/>
(1) When a new firmware version is available, a firmware update notification will automatically appear when using AtomStack Studio or the mobile app. You may also see a prompt in the firmware version interface asking whether to update or skip the update.<br/>
Note: When updating firmware through the software, the USB drive must be inserted into the machine.<br/>
(2) Copy the latest Master firmware file to the root directory of the USB drive using a computer, then insert the USB drive into the machine to start the automatic update process.<br/>
Note: The firmware file must be a \`.bin\` file and must not be placed inside a folder.<br/>
(3) If the USB drive included with the machine is damaged, please use another USB drive with a capacity of 32 GB or less.`,
          video_url: ['https://youtu.be/FVvSCQzg5pQ'],
        },
        {
          Q: `Master Water Tank Refill and Water Replacement Guide`,
          A: `Please refer to the Master water tank refill and replacement tutorial video.<br/>
Note:<br/>
(1) The water tank must be filled with suitable distilled water, purified water, or high-purity water. The water level should remain between the minimum and maximum level marks.<br/>
(2) It is recommended to replace the water in the tank every 30 days.<br/>
(3) When the ambient temperature is below 5°C, a non-corrosive antifreeze solution must be added to the water tank. The recommended mixing ratio is as follows:<br/>
[table:master_part1_q16_table1]`,
          tables: {
            master_part1_q16_table1: {
              headers: [
                `Minimum operating temperature`,
                `Antifreeze-to-water ratio`,
              ],
              rows: [
                [`-45℃~-42℃`, `6:4 (60% antifreeze and 40% water)`],
                [`-35℃~-32℃`, `5:5 (50% antifreeze and 50% water)`],
                [`-25℃~-22℃`, `4:6 (40% antifreeze and 60% water)`],
                [`-15℃~-12℃`, `3:7 (30% antifreeze and 70% water)`],
                [`-5℃~0℃`, `2:8 (20% antifreeze and 80% water)`],
              ],
            },
          },
          video_url: ['https://youtu.be/r1JTiRWBDVs'],
        },
        {
          Q: `AtomStack Studio and Mobile App Updates`,
          A: `Please refer to the AtomStack Studio and mobile app update tutorial video.<br/>
Note: When a new version is released, the software and mobile app will automatically notify users of the available update when opened. Users may choose whether to update.`,
          video_url: ['https://youtu.be/TYNIlAgJrhk'],
        },
        {
          Q: `Materials Prohibited for Processing with the Master`,
          A: `The following materials must not be processed:<br/>
* PVC (releases chlorine gas)<br/>
* Chlorine-containing plastics<br/>
* Metals with unknown coatings<br/>
* Highly reflective mirror-like materials (laser reflections may damage the laser system)<br/>
Note: When processing unknown materials, it is recommended to perform a low-power test first.`,
          video_url: [],
        },
      ],
      // Category 3: Part 2
      [
        {
          Q: `Master Maintenance Schedule and Service Frequency Table.`,
          A: `[table:master_part2_q1_table1]`,
          tables: {
            master_part2_q1_table1: {
              headers: [
                `Items`,
                `Recommended Cleaning Frequency (It is recommended to use anhydrous ethanol and a lint-free cloth for cleaning.)`,
              ],
              rows: [
                [`Reflective Mirror`, `For high-frequency users:
Mirror #1: once every 2 weeks
Mirror #2: once per week
Mirror #3: once per day
For low-frequency users:
Mirror #1: once per month
Mirror #2: once every 2 weeks
Mirror #3: once per week`],
                [`Focusing lens`, `Clean once every approximately 3 hours of operation.`],
                [`IR laser lens`, `For high-frequency users, cleaning is recommended once per day. For low-frequency users, cleaning is recommended once per week.`],
                [`Dual shafts`, `For high-frequency users: once per week
For low-frequency users: once every 2 weeks`],
                [`Fan`, `For high-frequency users: once every 15 days
For low-frequency users: once per month`],
                [`Machine Frame`, `For high-frequency users: once every 15 days
For low-frequency users: once per month`],
                [`Camera`, `Recommended: once per week.`],
              ],
            },
          },
          video_url: [],
        },
        {
          Q: `Cleaning the Reflective Mirrors of Master`,
          A: `Please refer to the cleaning tutorial video of reflective mirror and focusing lens of Master.<br/>
Note:<br/>
(1) Risks of not cleaning the mirrors:<br/>
Dirty reflective mirrors can reduce the CO₂ laser power and may also cause laser energy to concentrate on the mirror surface, potentially damaging the mirrors.<br/>
(2) Cleaning tools:<br/>
Lint-free cloth + anhydrous ethanol.<br/>
(3) Cleaning method:<br/>
* Cleaning Mirror #1:<br/>
First open the laser tube protective cover, then quickly remove the Mirror #1 holder tray. Use a lint-free cloth dampened with anhydrous ethanol to gently wipe the mirror surface.<br/>
Note: Wipe in a single direction only (for example, in a spiral motion from the center outward) to avoid scratches caused by back-and-forth rubbing.<br/>
* Cleaning Mirror #2:<br/>
Quickly remove the Mirror #2 holder tray directly, then use a lint-free cloth dampened with anhydrous ethanol to gently wipe the mirror surface.<br/>
Note: Wipe in a single direction only (for example, in a spiral motion from the center outward) to avoid scratches caused by back-and-forth rubbing.<br/>
* Cleaning Mirror #3:<br/>
First remove the magnetic protective cover, then quickly remove the Mirror #3 holder tray. Use a lint-free cloth dampened with anhydrous ethanol to gently wipe the mirror surface.<br/>
Note: Wipe in a single direction only (for example, in a spiral motion from the center outward) to avoid scratches caused by back-and-forth rubbing.<br/>
(4) Cleaning result inspection:<br/>
After cleaning, inspect the mirror surface under strong side lighting to ensure that no water stains or fibers remain.<br/>
(5) Recommended cleaning frequency:<br/>
For high-frequency users:<br/>
* Mirror #1: once every 2 weeks<br/>
* Mirror #2: once per week<br/>
* Mirror #3: once per day<br/>
(6) Precautions:<br/>
Do not use ordinary cotton cloth or gauze for cleaning, as they may leave water stains or lint residue. The cleaning agent must be non-corrosive.`,
          video_url: ['https://youtu.be/jDrHaLSiwkI'],
        },
        {
          Q: `Cleaning the Focusing Lens of Master`,
          A: `Please refer to the video on cleaning the Master reflector and focusing lens .<br/>
Note:<br/>
(1) Risks of not cleaning the lens:<br/>
A dirty focusing lens can reduce the CO₂laser power and may also cause laser energy to concentrate on the lens surface, potentially damaging the focusing lens.<br/>
(2) Recommended cleaning tools:<br/>
Use a lint-free cloth or optical-grade lint-free cotton swabs for cleaning (avoid ordinary cotton swabs that may shed fibers).<br/>
Use 99% anhydrous ethanol or a professional optical lens cleaner (avoid solvents containing ammonia or acetone).<br/>
(3) Cleaning method:<br/>
Use a lint-free cloth dampened with 99% anhydrous ethanol or a professional optical lens cleaner (avoid solvents containing ammonia or acetone) to wipe the lens surface.<br/>
Wipe in a single direction only (for example, in a spiral motion from the center outward) to avoid scratches caused by back-and-forth rubbing.<br/>
(4) Cleaning result inspection:<br/>
After cleaning, inspect the lens surface under strong side lighting to ensure that no water stains or fibers remain.<br/>
(5) Recommended cleaning frequency:<br/>
Clean once every 3 hours of operation.<br/>
(6) Precautions:<br/>
Do not use ordinary cotton cloth or gauze for cleaning, as they may leave water stains or lint residue. The cleaning agent must be non-corrosive, otherwise the focusing lens may be damaged directly.<br/>
When cleaning the focusing lens, also check whether the air outlet of the airflow shield/nozzle is clean. If dirt or residue is present, clean it promptly.`,
          video_url: [],
        },
        {
          Q: `Cleaning the Master Enclosure`,
          A: `Please refer to the Master enclosure cleaning tutorial video.<br/>
Note:<br/>
(1) X/Y Rail Cleaning:<br/>
Use a lint-free cloth dampened with anhydrous ethanol to gently wipe away dirt, dust, and debris from the X/Y rails.<br/>
Recommended cleaning frequency:<br/>
* High-frequency users: once per week<br/>
* Low-frequency users: once every two weeks<br/>
(2) Machine Frame Cleaning:<br/>
Use a lint-free cloth dampened with anhydrous ethanol to gently wipe dirt and dust from the machine frame, outer housing, and interior surfaces.<br/>
Recommended cleaning frequency:<br/>
* High-frequency users: once every two weeks<br/>
* Low-frequency users: once per month<br/>
(3) Fan Cleaning:<br/>
Use a lint-free cloth dampened with anhydrous ethanol to gently wipe dirt and dust from the fans.<br/>
Note: The exhaust fan may accumulate oily residue, so make sure it is cleaned thoroughly.<br/>
Recommended cleaning frequency:<br/>
* High-frequency users: once every two weeks<br/>
* Low-frequency users: once per month<br/>
(4) Precautions:<br/>
* Avoid using cleaning agents that contain ammonia, acetone, or similar solvents.<br/>
* Do not apply excessive force while wiping, as this may cause scratches or damage.<br/>
* Keep the machine operating environment dry. Long-term operation in humid environments is not recommended.`,
          video_url: ['https://youtu.be/CEvWegvzANo'],
        },
        {
          Q: `What Happens If the Water Tank of Master Is Not Replaced for a Long Time?`,
          A: `(1) It can lead to scale buildup inside the water circulation system.<br/>
(2) It can reduce cooling efficiency.<br/>
(3) In severe cases, it may damage the CO₂ laser tube.`,
          video_url: [],
        },
        {
          Q: `How to Determine Whether the Reflective Mirrors or Focusing Lens of Master Need Replacement`,
          A: `(1) If the surface shows signs of burning, yellowing, or stains that cannot be cleaned off.<br/>
(2) If the cutting performance has noticeably weakened.`,
          video_url: [],
        },
        {
          Q: `Precautions for Long-Term Inactivity of the Master`,
          A: `If the engraving machine will not be used for an extended period, store it in a dry environment. It is recommended to power on and run the machine for 5 minutes once a month to help maintain the lifespan of the electronic components.`,
          video_url: [],
        },
      ],
      // Category 4: Part 4
      [
        {
          Q: `Master Troubleshooting Quick Reference`,
          A: `[table:master_part4_q1_table1]`,
          tables: {
            master_part4_q1_table1: {
              headers: [
                `Symptom`,
                `Check First`,
              ],
              rows: [
                [`Cannot power on`, `Check power cable, emergency stop switch status, switching power supply indicator light, measure motherboard power cable voltage`],
                [`Control screen not displaying`, `Check control screen for physical damage, check motherboard cable connections, confirm firmware version`],
                [`Connection failed`, `Check baud rate, Type-C cable port, computer USB port, CH340 driver`],
                [`Camera malfunction`, `Check computer camera permissions, camera cable connection, verify camera output`],
                [`Power degradation`, `Check focal distance, software parameters, light path verification, clean reflector and focusing lens`],
                [`Blurry engraving`, `Check focal distance, clean reflector and focusing lens, ensure material is not shifting`],
                [`Homing failed`, `Check motor status, limit switch status, firmware version`],
                [`Distorted engraving pattern`, `Check timing belt tension, X/Y axis synchronous wheel screws, X-axis parallelism`],
                [`Unclosed engraving lines`, `Check focal distance, engraving parameters, focusing lens, light path; enable constant power, adjust minimum power value`],
                [`Engraving stops midway`, `Confirm alarm message, check Type-C cable, computer port, try different software`],
                [`Alarm: travel limit reached`, `Confirm if limit switch was triggered, check limit switch status, firmware version`],
                [`Auto-focus failed`, `Check material properties, upper/lower limit switch status, Z-axis motor status`],
                [`Flame alarm`, `Check working environment, line density, engraving material, adjust sensitivity`],
                [`APP connection failed`, `Confirm WiFi mode is enabled, WiFi name is searchable, turn off mobile data, try a different phone`],
              ],
            },
          },
          video_url: [],
        },
        {
          Q: `Master Cannot Power On Normally, and the Power Indicator Light Is Off`,
          A: `Solution: Please refer to the Master power-on troubleshooting video.<br/>
(1) Check the voltage specification:<br/>
Make sure the machine matches the local mains voltage. Master is available in both 220V and 110V versions for different regional power standards.<br/>
(2) Check the power cable:<br/>
Make sure the power cable is securely connected. Unplug the power cable and reconnect it firmly.<br/>
(3) Check the emergency stop switch:<br/>
Make sure the emergency stop switch has been released. Press the knob, rotate it clockwise, and then release it.<br/>
(4) If the issue still cannot be resolved, the power switch may be faulty. Please provide a photo of the machine’s Serial Number (see Figure 20) and a video showing the issue to customer service for assistance.<br/>
For power switch replacement instructions, please refer to the Master power switch replacement video.<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_20.png:Figure 20]`,
          video_url: ['https://youtu.be/QdWJ6rasLKg', 'https://youtu.be/slFe8EOmrTg'],
        },
        {
          Q: `Master Cannot Power On Normally, but the Power Indicator Light Is On`,
          A: `Solution: Please refer to the Master power-on troubleshooting video.<br/>
(1) Check whether there is a buzzer sound after powering on:<br/>
If there is no buzzer sound, it indicates that the mainboard has not started properly. First, check whether the indicator light on the mainboard is on.<br/>
(2) Check the mainboard indicator light:<br/>
* If the mainboard indicator light is on, but there is no buzzer sound and the machine cannot connect normally:<br/>
This may indicate a mainboard failure. Disconnect all cables connected to the mainboard except for the mainboard power cable (see Figure 21), then restart the machine to check whether the buzzer sound can be heard and whether the machine can connect properly.<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_21.png:Figure 21]<br/>
--- If the machine starts normally and connects properly after disconnecting the other cables, reconnect the cables one by one to identify which cable is causing the issue, then report the results to customer service for assistance.<br/>
--- If there is still no buzzer sound, the mainboard is likely faulty. Please send the machine’s Serial Number and a video showing the issue to customer service for assistance. For mainboard replacement instructions, please refer to the Master mainboard replacement video.<br/>
* If the mainboard indicator light is not on:<br/>
This may indicate a switching power supply failure. If you have a multimeter, use the DC voltage mode to measure whether the input voltage between the red and black wires of the mainboard power cable is 24V (see Figure 22).<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_22.png:Figure 22]<br/>
--- If no voltage is detected, the switching power supply is considered faulty. Please send the machine’s Serial Number (see Figure 23) and a video of the voltage measurement to customer service for assistance. For switching power supply replacement instructions, please refer to the Master switching power supply replacement video.<br/>
--- If 24V is measured but the mainboard appears to be continuously restarting, the switching power supply may still be faulty.<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_23.png:Figure 23]`,
          video_url: ['https://youtu.be/sJrvQ6Foodo', 'https://youtu.be/slFe8EOmrTg', 'https://youtu.be/GsXllQNKMo0', 'https://youtu.be/F3zHj7dpTjQ'],
        },
        {
          Q: `Master Cannot Connect to the Computer`,
          A: `Solution: Please refer to the Master connection troubleshooting video.<br/>
(1) Confirm that the machine has started normally:<br/>
Check whether you can hear the mainboard buzzer sound.<br/>
* If the buzzer sound is heard, the machine has started normally.<br/>
* If there is no buzzer sound, please refer to the “Master Cannot Power On Normally” section for troubleshooting.<br/>
(2) Check whether the Type-C cable is properly connected:<br/>
Disconnect the Type-C cable from both ends and reconnect it to the machine and the computer USB port, or try a different USB port on the computer.<br/>
(3) Confirm the operating system:<br/>
* Windows computers can directly use a Type-C to USB-A cable or a USB-C connection.<br/>
* macOS or HarmonyOS computers require a docking station/hub (see Figure 24) to connect the USB-A end of the Type-C cable.<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_24.png:Figure 24]<br/>
(4) Check the serial port:<br/>
* When using AtomStack Studio, no additional confirmation is required.<br/>
* When using LightBurn, make sure the correct serial port is selected. Check which COM port the CH340 device is assigned to in the computer’s Device Manager (see Figure 25).<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_25.png:Figure 25]<br/>
(5) Make sure no other software is occupying the connection:<br/>
Ensure that no other software is currently connected to the engraving machine.<br/>
(6) Check the configured controller:<br/>
* AtomStack Studio does not require additional setup.<br/>
* When using LightBurn, make sure a GRBL controller has been added or import the factory configuration file included with the Master. Please refer to the LightBurn connection section in the Master online connection tutorial video.<br/>
Check the serial port driver:<br/>
In Device Manager, check whether a CH340 serial device is present. If not, please install the serial driver first. Driver download links are as follows:<br/>
----Windows driver download link: [https://asa.atomstack.com/downloadWindowsDrivers.do3](https://asa.atomstack.com/downloadWindowsDrivers.do3)<br/>
----Mac driver download link: [https://asa.atomstack.com/downloadMacDrivers.do3](https://asa.atomstack.com/downloadMacDrivers.do3)<br/>
(7) Check the baud rate:<br/>
* AtomStack Studio does not require this setting to be checked.<br/>
* When using LightBurn, make sure the baud rate is set to 460800 (see Figure 26).<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_26.png:Figure 26]<br/>
(8) Check the computer and software:<br/>
If possible, try connecting the machine using another computer to determine whether the connection works properly.<br/>
(9) If the issue still cannot be resolved after completing the above steps, please send a video showing the issue, the troubleshooting steps already performed, and the machine’s Serial Number (see Figure 27) to customer service for assistance.<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_27.png:Figure 27]<br/>
For mainboard replacement instructions, please refer to the Master mainboard replacement video.`,
          video_url: ['https://youtu.be/kUMOodCElFc'],
        },
        {
          Q: `Master’s Control Screen Has No Display After Powering On`,
          A: `Solution:<br/>
(1) Confirm that the machine powers on normally:<br/>
Make sure you can hear the mainboard buzzer sound during startup and that the machine can be controlled normally when connected to a computer.<br/>
If the machine does not start properly, please refer to the “Master Cannot Power On Normally” section.<br/>
(2) Check the status of the control panel: Carefully inspect whether the control panel has been damaged during transportation.<br/>
(3) Check the mainboard cable connections:<br/>
Open the internal cover panel of the enclosure and check whether the control screen cable is loose (see Figure 28).<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_28.png:Figure 28]<br/>
(4) Check the mainboard firmware version:<br/>
After connecting the machine, check the current firmware version in AtomStack Studio and send a screenshot to customer service so they can verify whether the firmware version is correct (see Figure 29).<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_29.png:Figure 29]<br/>
(5) If no issues are found after completing the above checks, the control screen may be faulty. Please send a video showing the issue, the troubleshooting steps already performed, and the machine’s Serial Number (see Figure 30) to customer service for assistance.<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_30.png:Figure 30]<br/>
For control screen replacement instructions, please refer to the Master control screen replacement video.`,
          video_url: ['https://youtu.be/jR4jtnATJLA'],
        },
        {
          Q: `Camera of Master Cannot Be Used`,
          A: `Solution: Please refer to the Master camera troubleshooting video.<br/>
(1) Check the coordinate mode selected in the software:<br/>
When using the camera, Absolute Coordinates mode must be enabled.<br/>
(2) Check whether the camera is disabled:<br/>
Open Device Manager and check whether the camera has been restricted or disabled. Make sure the necessary permissions are enabled and access is allowed (see Figure 31).<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_31.png:Figure 31]<br/>
(3) Check whether the computer USB port is faulty:<br/>
Try connecting to a different USB port on the computer, and use the computer’s built-in camera application to check whether the camera outputs an image (see Figure 32).<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_32.png:Figure 32]<br/>
(4) Check whether the camera USB cable on the mainboard is loose:<br/>
If no image is displayed, check whether the camera USB cable connected to the mainboard is loose (see Figure 33). Disconnect and reconnect the cable, then test the camera function again.<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_33.png:Figure 33]<br/>
(5) Check whether the camera cable connection is loose:<br/>
Use a flat-head screwdriver to pry open the camera protective cover (see Figure 34), then check whether the cable connector is loose.<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_34.png:Figure 34]<br/>
(6) If the above steps do not resolve the issue and the computer’s built-in camera application still cannot display an image, please send a video showing the issue, the troubleshooting steps already performed, and the machine’s Serial Number (see Figure 35) to customer service for assistance.<br/>
For camera replacement instructions, please refer to the Master camera replacement video.<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_35.png:Figure 35]`,
          video_url: ['https://youtu.be/zP6VBpehcbs', 'https://youtu.be/3d4Zqn89UnY', 'https://youtu.be/-9bKQBm_LOY'],
        },
        {
          Q: `Master’s Camera Positioning Is Inaccurate or Has Large Errors`,
          A: `Solution:<br/>
(1) Check the coordinate mode selected in the software:<br/>
When using the camera, Absolute Coordinates mode must be enabled.<br/>
(2) Confirm that calibration has been completed:<br/>
* When using AtomStack Studio, only alignment is required.<br/>
* When using LightBurn, follow the instructions in the manual and complete the calibration step by step according to the software prompts. Please refer to the Master camera operation video for calibration guidance.<br/>
Note: LightBurn version 1.7.03 or later is recommended, as it provides easier operation and higher calibration accuracy.<br/>
(3) Make sure the interior lighting is bright enough:<br/>
The enclosure lighting brightness can be adjusted from the control screen. When using the camera, set the lighting brightness to the maximum level (see Figure 36).<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_36.png:Figure 36]<br/>
(4) Make sure the air pump is turned off:<br/>
During camera calibration, disable the air assist/air pump function from the control screen (see Figure 37).<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_37.png:Figure 37]<br/>
(5) Check the material height:<br/>
The height used during calibration should match, or be very close to, the height of the actual engraving material. If the material height differs significantly from the calibration height, recalibration is required.<br/>
(6) Check the calibration tool:<br/>
Kraft paper is recommended for alignment, although plywood may also be used. The calibration piece should be flat and have clear, easily distinguishable lines.<br/>
(7) Confirm operational details:<br/>
If lightweight pieces such as kraft paper are used during calibration, make sure they are securely fixed in place to prevent movement during engraving.`,
          video_url: [],
        },
        {
          Q: `The Master CO₂ Laser Power Is Abnormal and Cannot Fully Cut Through Materials`,
          A: `Solution: Please refer to the Master laser power troubleshooting video.<br/>
(1) Check the reflective mirrors:<br/>
With the machine powered off, remove and inspect Mirrors #1, #2, and #3 to check whether they are clean (see Figure 38). If they are dirty, clean them using anhydrous ethanol and a lint-free cloth. Please refer to the “Master Reflective Mirror Cleaning” section for cleaning instructions.<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_38.png:Figure 38]<br/>
(2) Check whether the red guide laser dot overlaps with the laser burn spot:<br/>
Attach a piece of masking tape or white paper to the focusing lens frame. Press the Laser Test button on the control screen or in the software to briefly fire the laser, then check whether the burn mark overlaps with the red guide laser dot.<br/>
If they do not overlap, open the internal shield panel and adjust the beam combiner module screws located in front of the CO₂ laser tube (see Figure 39) until the red guide dot and burn mark align.<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_39.png:Figure 39]<br/>
(3) Check the red guide laser position in the optical path:<br/>
With the machine powered on, attach a piece of masking tape or white paper to the third mirror (Z-axis mirror) and mark the current red guide laser position with a pen.<br/>
Then move the X-axis and Y-axis around the four inner edges of the enclosure and check whether the red guide laser position shifts relative to the marked point.<br/>
If the position shifts, the optical path must be realigned. Please refer to the Master optical path verification and calibration video.<br/>
(4) Check the cutting performance:<br/>
Cut a large square-shaped piece of material and check whether all sides are fully cut through.<br/>
If one side cuts through properly while another side does not, the optical path needs to be realigned.<br/>
(5) Check the focusing lens:<br/>
Remove the cover of the focusing lens tube and take out the focusing lens(see Figure 40). Check whether the focusing lens is damaged.<br/>
If it is only dirty, please refer to the “Master Focusing Lens Cleaning” section for cleaning instructions.<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_40.png:Figure 40]<br/>
(6) If no issues are found after completing the above checks, please send the following information to customer service for assistance:<br/>
* A video showing the optical path verification process<br/>
* A cutting test video (clearly showing the software power settings, material type, and material thickness)<br/>
* A photo of the machine’s Serial Number (see Figure 41)<br/>
For laser tube replacement instructions, please refer to the Master laser tube replacement video.<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_41.png:Figure 41]`,
          video_url: ['https://youtu.be/e7lGw0yp2mo', 'https://youtu.be/CLkKbGJzN8E'],
        },
        {
          Q: `The Master Engraving Output Is Blurry`,
          A: `Solution:<br/>
(1) Check the focus distance:<br/>
The auto focus distance is 8 mm. Please confirm that the distance between the bottom of the Z-axis focusing lens tube and the material surface is 8 mm.<br/>
(2) Check the lenses and mirrors:<br/>
After powering off the machine, inspect Mirrors #1, #2, #3, and the focusing lens for dirt or contamination (see Figure 42). If necessary, please refer to the “Master Reflective Mirror Cleaning” and “Master Focusing Lens Cleaning” sections for cleaning instructions.<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_42.png:Figure 42]<br/>
(3) Check whether the material has shifted:<br/>
If the engraving material is thin or lightweight, secure it properly to prevent movement during the engraving process.`,
          video_url: [],
        },
        {
          Q: `The Master Engraving Output Has Ghosting or Double Images`,
          A: `Solution:<br/>
(1) Check the timing belts:<br/>
Press the X-axis and Y-axis timing belts by hand to check whether they are too loose or too tight. If adjustment is needed, use the belt tensioners located on the right side of the X-axis and the inner side of the Y-axis to adjust the belt tension (see Figure 43).<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_43.png:Figure 43]<br/>
(2) Check the X/Y timing pulley screws:<br/>
To inspect the timing pulley screws, the outer cover and the X-axis motor mounting screws must first be removed. Please refer to the Master structural adjustment video.<br/>
(3) Check whether the X-axis is parallel to the upper and lower frame edges:<br/>
Use a ruler to measure whether the distances from both ends of the X-axis to the lower enclosure frame are equal.<br/>
If the distances are inconsistent, adjustment is required. Loosen the coupling screws on the Y-axis motor to make the adjustment. Please refer to the structural adjustment video.<br/>
(4) Check the software parameters:<br/>
Verify whether the engraving speed set in the software is too high. Please refer to the recommended parameter table. The speed unit is mm/min.<br/>
(5) Check whether the material has shifted:<br/>
If the engraving material is thin or lightweight, secure it properly to prevent movement during the engraving process.`,
          video_url: ['https://youtu.be/c_o33kjnr_A'],
        },
        {
          Q: `The Master Fails to Home Properly`,
          A: `Solution: Please refer to the Master homing failure troubleshooting video.<br/>
Check the homing process:<br/>
When the Reset/Home button is pressed, the machine follows this homing sequence:<br/>
① Home the Z-axis<br/>
② Move the Y-axis<br/>
③ Move the X-axis<br/>
Please identify at which step the issue occurs and observe the machine behavior. Troubleshoot according to the following steps.<br/>
(1) Check the motor status:<br/>
Use the directional buttons on the control screen (see Figure 44) to move the X-axis, Y-axis, and Z-axis motors and check whether they all operate normally.<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_44.png:Figure 44]<br/>
If a motor cannot move properly:<br/>
* Disconnect the motor cable and reconnect it, then test again.<br/>
* Note: Accessing the Y-axis motor requires removing the outer cover. If the Y-axis moves normally, this step is unnecessary.<br/>
If the issue persists, please send a video showing the issue, the troubleshooting steps already performed, and a photo of the machine’s Serial Number to customer service for assistance.<br/>
For motor replacement instructions, please refer to the Master motor replacement video.<br/>
(2) Check the limit switches:<br/>
Check the following limit switches one by one:<br/>
* Z-axis upper limit switch<br/>
* X-axis limit switches (2)<br/>
* Y-axis limit switches (2)<br/>
Press each switch and check whether a corresponding trigger notification appears.<br/>
If no response is detected, please send a video showing the issue and a photo of the machine’s Serial Number to customer service for assistance.<br/>
(3) Check the machine firmware version:<br/>
After connecting through AtomStack Studio or LightBurn, check the firmware version (see Figure 45 and Figure 46).<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_45.png:Figure 45]<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_46.png:Figure 46]<br/>
(4) If the issue still cannot be resolved after completing the above checks, please send the following information to customer service:<br/>
* A video clearly showing the operation steps, machine movements, and any alarm messages<br/>
* The troubleshooting steps already performed<br/>
* A photo of the machine’s Serial Number (see Figure 47) 。<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_47.png:Figure 47]`,
          video_url: ['https://youtu.be/8azOANjRZvw', 'https://youtu.be/Yk38GHqGScw'],
        },
        {
          Q: `The Master Engraving Output Is Distorted`,
          A: `Solution: Please refer to the Master structural adjustment section.<br/>
(1) Check the timing belts:<br/>
Press the X-axis and Y-axis timing belts by hand to check whether they are too loose or too tight. If adjustment is needed, use the belt tensioners located on the right side of the X-axis and the inner side of the Y-axis to adjust the belt tension (see Figure 48).<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_48.png:Figure 48]<br/>
(2) Check the X/Y timing pulley screws:<br/>
To inspect the timing pulley screws, the outer cover and the X-axis motor mounting screws must first be removed. Please refer to the structural adjustment video.<br/>
(3) Check whether the X-axis is parallel to the upper and lower frame edges:<br/>
Use a ruler to measure whether the distances from both ends of the X-axis to the lower enclosure frame are equal.<br/>
If the distances are inconsistent, adjustment is required. Loosen the coupling screws on the Y-axis motor to make the adjustment. Please refer to the structural adjustment video.<br/>
(4) If the issue still cannot be resolved after completing the above checks, please send the following to customer service for assistance:<br/>
* A video showing the X-axis parallelism measurement<br/>
* A video showing the timing pulley screw inspection<br/>
* A video showing the timing belt inspection<br/>
* A photo of the machine’s Serial Number (see Figure 49).<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_49.png:Figure 49]`,
          video_url: ['https://youtu.be/c_o33kjnr_A'],
        },
        {
          Q: `The Engraved Lines from Master Are Not Fully Closed`,
          A: `Solution: Please refer to the Master open-line troubleshooting section.<br/>
(1) Check the focus distance:<br/>
Measure the distance between the bottom of the Z-axis focusing assembly and the material surface to confirm that it is 8 mm.<br/>
If the distance is incorrect, refocus the machine. Please refer to the “Master Focus Distance Adjustment” section.<br/>
(2) Check the focusing lens:<br/>
Unscrew the focusing lens tube cover and remove the focusing lens to check for dirt or damage(see Figure 50).<br/>
If the lens is dirty, clean it using anhydrous ethanol and a lint-free cloth. Please refer to the “Master Focusing Lens Cleaning” section.<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_50.png:Figure 50]<br/>
(3) Check the software parameter settings:<br/>
Use the recommended parameter settings for the corresponding material according to the parameter chart. Incorrect parameter settings may result in insufficient laser energy.<br/>
Note: The speed unit is mm/min.<br/>
How to access the Master parameter chart:<br/>
① Scan the QR code on the engraving machine to view it.<br/>
② Contact customer service to request the parameter chart.<br/>
(4) Check the laser optical path:<br/>
Perform verification and troubleshooting according to the “Master Optical Path Verification and Calibration” section.<br/>
(5) Enable Constant Power Mode:<br/>
Turn on the Constant Power function in the software and check whether the issue is resolved(see Figure 51).<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_51.png:Figure 51]<br/>
(6) Adjust the minimum power value ($31):<br/>
① In AtomStack Studio:<br/>
Open the Settings menu, then continuously left-click the software version field more than 7 times to enable the developer mode menu called “Serial Port Log.”<br/>
Open “Serial Port Log,” then enter the following command in the input field:<br/>
\`$31=*\`(see Figure 52)<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_52.png:Figure 52]<br/>
Replace * with a specific value and gradually increase it until the lines close properly.<br/>
For example:<br/>
If the lines do not close when \`$31=0\`, send:<br/>
\`$31=10\`<br/>
If the issue persists, continue increasing the value, for example:<br/>
\`$31=20\`<br/>
Repeat until the engraved lines close properly.<br/>
② In LightBurn:<br/>
Go to “Edit” → “Machine Settings,” then locate the \`$31\` parameter.<br/>
Increase the value, click “Write,” then click “OK” to save the setting.<br/>
Repeat this process and continue increasing the \`$31\` value until the lines close properly.`,
          video_url: ['https://youtu.be/SGcbE-3NK0w'],
        },
        {
          Q: `Master Auto Focus Failure`,
          A: `Solution: Please refer to the Master auto focus troubleshooting guide.<br/>
(1) Confirm that the auto focus function is enabled:<br/>
After connecting the machine, check whether the auto focus function is enabled in the machine function settings page of AtomStack Studio (see Figure 53).<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_53.png:Figure 53]<br/>
(2) Confirm that material is placed on the blade bed:<br/>
If no material is placed on the bed, the Z-axis may not be able to detect or contact the material properly, which can cause auto focus to fail.<br/>
(3) Confirm the material type:<br/>
If the material is soft or flexible, please use the Z-axis movement controls on the control screen to perform manual focusing instead. The focus distance should be 8 mm (see Figure 54).<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_54.png:Figure 54]<br/>
(4) Check the Z-axis upper and lower limit switches:<br/>
* Gently push the focusing lens tube upward by hand to check whether the lower limit switch can be triggered(see Figure 55). If it can be triggered, the lower limit switch is functioning normally.<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_55.png:Figure 55]<br/>
* Use the Z-axis movement controls on the control screen to move the Z-axis upward. When it reaches the top position, check whether the upper limit switch is triggered. If it can be triggered, the upper limit switch is functioning normally.<br/>
① If the lower limit switch cannot be triggered properly:<br/>
Open the cover at the top of the Z-axis and check whether the lower limit switch cable is loose (see Figure 56).<br/>
If the cable connection is normal, the lower limit switch board may be faulty. Please refer to the Master limit switch replacement video for replacement instructions.<br/>
② If the upper limit switch cannot be triggered properly:<br/>
Open the cover at the top of the Z-axis and check whether the upper limit switch cable is loose (see Figure 57).<br/>
Disconnect and reconnect the cable, then manually press the upper limit switch to check whether it can be triggered normally.<br/>
If it still cannot be triggered, the upper limit switch board is likely faulty. Please refer to the Master limit switch replacement video for replacement instructions.<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_56.png:Figure 56]<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_57.png:Figure 57]<br/>
(5) Check the motor status:<br/>
If the Z-axis motor makes noise during the auto focus process but does not move:<br/>
* Use the Z-axis movement controls on the control screen to move the Z-axis up and down and check whether the movement is smooth.<br/>
--- If the Z-axis moves smoothly using the control buttons, the issue may be firmware-related. Please send the machine’s Serial Number (see Figure 58), a video showing the issue, and the troubleshooting steps already performed to customer service for assistance.<br/>
--- If abnormal behavior also occurs when using the control buttons, open the cover at the top of the Z-axis and check whether the Z-axis motor cable is loose. Disconnect and reconnect the cable. Also check whether the cable is damaged (see Figure 59).<br/>
--- If the cable and connector appear normal, manually rotate the Z-axis motor lead screw (see Figure 60) to check whether the Z-axis linear guide rail is functioning properly. If any abnormality is found, please send a video showing the issue to customer service for assistance.<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_58.png:Figure 58]<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_59.png:Figure 59]<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_60.png:Figure 60]<br/>
(6) If the above steps do not resolve the issue, please send the following to customer service:<br/>
* A video showing the auto focus failure<br/>
* A video showing the troubleshooting process<br/>
* The machine’s Serial Number`,
          video_url: ['https://youtu.be/jyE7tx4oKHE', 'https://youtu.be/VGDI8VWkCic'],
        },
        {
          Q: `Master Displays “Travel Limit Reached” During Operation`,
          A: `Solution: Please refer to the Master travel limit troubleshooting guide.<br/>
(1) Check whether a limit switch has been triggered:<br/>
Observe under what conditions the alarm appears and whether a limit switch has been physically triggered.<br/>
If a limit switch has been triggered, check whether the engraving file size exceeds the machine’s working area:<br/>
* CO₂ mode working area: 500 mm × 300 mm<br/>
* IR mode working area: 300 mm × 265 mm<br/>
If no limit switch appears to have been triggered, continue with the following troubleshooting steps.<br/>
(2) Check the limit switches:<br/>
Use the control screen to move the machine up, down, left, and right, and check whether all X-axis and Y-axis limit switches can be triggered properly.<br/>
You can also move the Z-axis to confirm whether all three Z-axis limit switches can be triggered normally.<br/>
If any switch cannot be triggered, or if the alarm appears during movement, follow these steps:<br/>
* First, confirm that the limit switch cables are securely connected. Disconnect and reconnect the cables.<br/>
* Check whether the limit switches have any physical damage.<br/>
(3) Check the machine firmware version:<br/>
In AtomStack Studio or LightBurn, check whether the machine firmware version is correct (see Figure 61 and Figure 62).<br/>
If the firmware version is not the latest version, please update it to the latest release.<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_61.png:Figure 61]<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_62.png:Figure 62]<br/>
(4) If the above steps do not resolve the issue, please send the following to customer service:<br/>
* A video showing the issue<br/>
* The troubleshooting steps already performed<br/>
* A photo of the machine’s Serial Number (see Figure 63)<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_63.png:Figure 63]`,
          video_url: ['https://youtu.be/ucsPOO4edNE'],
        },
        {
          Q: `The Master Stops During Engraving`,
          A: `Solution: Please refer to the Master engraving interruption troubleshooting guide.<br/>
(1) Check the software alarm messages:<br/>
After the machine stops, check whether the software displays any error or alarm messages. If there is an error message, troubleshoot according to the prompt.<br/>
◆ Travel Limit Reached<br/>
Please refer to the section: “The Master Displays ‘Travel Limit Reached’ During Operation.”<br/>
◆ Alarm 1<br/>
A limit switch has been triggered. Check carefully whether the engraving file exceeds the machine’s working area, or whether the machine has collided with a limit switch during operation.<br/>
◆ Alarm 3<br/>
The machine detected an automatic stop signal or another stop condition. Further troubleshooting is required based on the specific trigger condition.<br/>
◆ Alarm 12<br/>
A flame alarm has been triggered. Please check the following:<br/>
* Whether the engraving/cutting material is MDF, balsa wood, or similar materials<br/>
* Try replacing the material with basswood for testing<br/>
* Check whether the engraving/cutting design contains overly dense lines; if so, increase the speed and increase the number of engraving/cutting passes<br/>
* Check whether direct sunlight is shining into the machine, as direct sunlight may falsely trigger the flame alarm<br/>
◆ Alarm 13<br/>
The enclosure door is open. Check whether the enclosure door was opened during engraving.<br/>
If the door was not opened, the enclosure door limit switch may be faulty. Please send a video showing the issue, the alarm message, and the machine’s Serial Number to customer service for assistance.<br/>
If replacement is required, please refer to the Master limit switch replacement video.<br/>
◆ If no alarm message is displayed, continue with the following troubleshooting steps.<br/>
(2) Check the engraving progress bar in the software:<br/>
If the engraving progress bar in the software continues running even though the machine has stopped, the issue may be caused by abnormal data transmission.<br/>
Try the following:<br/>
* Use a different USB port on the computer<br/>
* Replace the Type-C cable<br/>
* Try a different engraving software (such as AtomStack Studio or LightBurn)<br/>
(3) If the above steps do not resolve the issue, please send the following to customer service:<br/>
* A video showing the issue<br/>
* Screenshots of any software messages or alarms<br/>
* The troubleshooting steps already performed<br/>
* A photo of the machine’s Serial Number (see Figure 64)<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_64.png:Figure 64]`,
          video_url: ['https://youtu.be/SZapclqwVec', 'https://youtu.be/VGDI8VWkCic'],
        },
        {
          Q: `The Master Does Not Respond After Pressing the Start Button`,
          A: `Solution:<br/>
(1) Check the machine status:<br/>
* Home the machine first<br/>
* Make sure the enclosure door is closed<br/>
* Confirm that the water tank has been filled and that the water level is above the minimum level<br/>
* Check the machine temperature displayed in the software<br/>
(2) Check the connection status:<br/>
Use the directional controls in the software to move the machine and check whether the connection has been disconnected.<br/>
(3) Check for software prompts:<br/>
After pressing the Start button, check whether any message or warning appears in the software. If a prompt appears, troubleshoot according to the message.<br/>
(4) Check the control screen information:<br/>
Check whether any alarm or warning message is displayed on the control screen.<br/>
(5) Restart the machine and software:<br/>
Close the machine and the software completely, then restart both and try again.<br/>
(6) Try different software:<br/>
Try using a different control software, such as AtomStack Studio or LightBurn.<br/>
(7) If the above steps do not resolve the issue, please send the following to customer service:<br/>
* A video showing the issue<br/>
* Screenshots of any software prompts or error messages<br/>
* The troubleshooting steps already performed<br/>
* A photo of the machine’s Serial Number (see Figure 65)<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_65.png:Figure 65]`,
          video_url: [],
        },
        {
          Q: `The Machine Moves During Engraving, but the Laser Tube Does Not Emit Laser`,
          A: `Solution: Please refer to the Master laser tube no-output troubleshooting guide.<br/>
(1) Check the laser power supply:<br/>
Turn off the machine power, open the internal shield panel, then power the machine back on and check whether the indicator light on the laser power supply (located on the right side near the laser tube) lights up normally.<br/>
If the indicator light does not turn on, the laser power supply may be faulty. Please send a video showing the issue and the machine’s Serial Number to customer service for assistance.<br/>
If replacement is required, please refer to the Master laser power supply replacement video.<br/>
(2) Check the laser power supply wiring:<br/>
With the power disconnected, inspect whether any cables connected to the laser power supply are loose. Disconnect and reconnect the cables, then test again.<br/>
(3) Check the laser tube wiring:<br/>
With the power disconnected, carefully inspect whether the wiring connections at both ends of the laser tube are secure.<br/>
Also check whether any cables are damaged or broken.<br/>
(4) Check the condition of the laser tube:<br/>
With the power disconnected, carefully inspect the laser tube for any signs of damage or cracking.<br/>
If damage is found, please provide clear photos, videos, and the machine’s Serial Number to customer service for assistance.<br/>
If replacement is required, please refer to the Master laser tube replacement video.<br/>
(5) If the above steps do not resolve the issue, please send the following to customer service:<br/>
* A video showing the issue<br/>
* Screenshots of any software prompts or error messages<br/>
* The troubleshooting steps already performed<br/>
* A photo of the machine’s Serial Number (see Figure 66)<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_66.png:Figure 66]`,
          video_url: ['https://youtu.be/O6Ds7PJULyo', 'https://youtu.be/e7lGw0yp2mo', 'https://youtu.be/meMvekQx4OU'],
        },
        {
          Q: `The Distance After Master Auto Focus Is Not 8 mm`,
          A: `Solution:<br/>
(1) Confirm the material type:<br/>
If the material is soft or flexible, please use manual focusing instead. The correct focus distance is 8 mm.<br/>
Use the Z-axis movement controls on the control screen to adjust the height manually. It is recommended to use Jog Mode for more precise adjustment.<br/>
(2) Confirm the auto focus process:<br/>
The auto focus sequence works as follows:<br/>
* The Z-axis first moves to the highest position<br/>
* Then moves downward until the lower limit switch is triggered<br/>
* Finally moves upward to the standard 8 mm focus height<br/>
If the auto focus process appears normal but the final distance is not 8 mm, you can adjust the auto focus distance parameter in LightBurn or LaserGRBL.<br/>
The default auto focus parameter value is 1.5.<br/>
Correction value calculation:<br/>
* If the actual measured distance is greater than 8 mm:<br/>
[<br/>
1.5 - (\\text{actual measured value} - 8)<br/>
]<br/>
* If the actual measured distance is less than 8 mm:<br/>
[<br/>
1.5 + (8 - \\text{actual measured value})<br/>
]<br/>
In the LightBurn **Console** window (see Figure 67), enter:<br/>
\`\`\`plaintext<br/>
$autoFocus/depth_max_mm=correction_value<br/>
\`\`\`<br/>
Then press Enter.<br/>
Example:<br/>
If the actual auto focus distance measures 9 mm, then:<br/>
[<br/>
1.5 - (9 - 8) = 0.5<br/>
]<br/>
So the command should be:<br/>
\`\`\`plaintext<br/>
$autoFocus/depth_max_mm=0.5<br/>
\`\`\`<br/>
For detailed operation steps, please refer to the Master auto focus distance adjustment guide.<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_67.png:Figure 67]`,
          video_url: ['https://youtu.be/x6lr2v9suzE'],
        },
        {
          Q: `The LED Light Strip Inside Master Enclosure Does Not Turn On`,
          A: `Solution: Please refer to the Master enclosure LED light strip troubleshooting guide.<br/>
(1) Confirm that the machine has started normally:<br/>
After powering on, make sure the mainboard starts normally, the buzzer sound is heard, and the machine can connect properly.<br/>
(2) Check the LED light strip wiring:<br/>
Turn off the power and remove the outer cover. Check whether the LED light strip cable connections are loose.<br/>
If you have a multimeter, you can also measure whether the voltage on the cable is abnormal.<br/>
(3) If the above checks show no issues, the LED light strip may be faulty. Please send the following to customer service:<br/>
* A video showing the issue<br/>
* Screenshots of any software prompts or messages<br/>
* The troubleshooting steps already performed<br/>
* A photo of the machine’s Serial Number (see Figure 68)<br/>
For replacement instructions, please refer to the Master enclosure LED light strip replacement video.<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_68.png:Figure 68]`,
          video_url: ['https://youtu.be/sLQe21v9Wig', 'https://youtu.be/sbD1LzK9X5k'],
        },
        {
          Q: `Smoke and Dust Inside the Master Enclosure Cannot Be Exhausted in Time and Leak Out Through the Door Gaps`,
          A: `Solution: Please refer to the Master smoke exhaust troubleshooting guide.<br/>
(1) Check whether an air purifier is being used:<br/>
If an air purifier is connected, disconnect the exhaust hose from the purifier and vent it directly outdoors. Then check whether the smoke inside the enclosure can be exhausted properly.<br/>
If the smoke can be exhausted normally after bypassing the purifier, the issue is likely caused by the air purifier.<br/>
(2) Check the exhaust fan condition:<br/>
The internal shield panel must be removed first.<br/>
◆ Check whether the fan is clean:<br/>
If there is excessive dust buildup on the fan, please refer to the “Master Enclosure Cleaning” section for cleaning instructions.<br/>
◆ Check whether the fan blades are intact:<br/>
If any fan blades are broken or damaged, please send clear photos and a photo of the machine’s Serial Number (see Figure 69) to customer service for assistance.<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_69.png:Figure 69]<br/>
For fan replacement instructions, please refer to the Master enclosure fan replacement video.<br/>
(3) Check the fan wiring:<br/>
After removing the shield panel, inspect the fan cable connections and confirm that the cables are securely connected (see Figure 70).<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_70.png:Figure 70]<br/>
(4) Supply power directly to the fan:<br/>
Use an external 12V or 24V power adapter and connect it to the fan terminals using two additional wires to check whether the fan rotates normally (see Figure 71).<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_71.png:Figure 71]<br/>
(5) If the fan is confirmed to be faulty, please send the following to customer service:<br/>
* A video showing the issue<br/>
* The troubleshooting steps already performed<br/>
* A photo of the machine’s Serial Number`,
          video_url: ['https://youtu.be/e4dFU5VwsqI', 'https://youtu.be/9m0gHxiDEDg'],
        },
        {
          Q: `The Master’s Flame Detection Function Fails and No Alarm Is Triggered Even When a Fire Occurs`,
          A: `Solution: Please refer to the Master flame detection troubleshooting guide.<br/>
(1) Confirm that the flame detection function is enabled:<br/>
After connecting the machine, check in AtomStack Studio whether the flame detection function is enabled (see Figure 72).<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_72.png:Figure 72]<br/>
(2) Check the flame detection board wiring:<br/>
Open the Z-axis shield cover and check whether the cable connected to the flame detection board is loose (see Figure 73).<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_73.png:Figure 73]<br/>
Also inspect the cable for any damage or breakage.<br/>
(3) Test the flame detection board function:<br/>
Use a regular lighter (not a windproof lighter) to create a flame and place it under the flame detection board for about 1 second. Check whether the alarm is triggered.<br/>
If the alarm is not triggered while all other machine functions operate normally, the flame detection board is likely faulty.<br/>
Please send the following to customer service:<br/>
* A video showing the issue<br/>
* The troubleshooting process already performed<br/>
* A photo of the machine’s Serial Number (see Figure 74)<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_74.png:Figure 74]<br/>
For replacement instructions, please refer to the Master flame detection board replacement video.`,
          video_url: ['https://youtu.be/vKgYhxPBUDI', 'https://youtu.be/2rLI6SMSBxw'],
        },
        {
          Q: `The Master’s Flame Detection Function Triggers False Alarms When No Fire Is Present`,
          A: `Solution:<br/>
(1) Check the working environment:<br/>
If the engraving machine is exposed to direct sunlight, the flame alarm may be triggered falsely. Move the machine to another location or block direct sunlight exposure.<br/>
(2) Check the engraving or cutting file design:<br/>
If the engraving or cutting file contains extremely dense lines, it may falsely trigger the flame alarm. Try increasing the speed and increasing the number of passes to reduce the chance of false alarms.<br/>
(3) Check the material being processed:<br/>
If the engraving or cutting material is highly flammable, such as MDF, balsa wood, cork, or paper, it may easily trigger the flame alarm.<br/>
You may disable the flame detection function before engraving or cutting these materials. However, when the flame detection function is disabled, the machine must be continuously supervised during operation to prevent accidents.<br/>
(4) Adjust the flame detection sensitivity:<br/>
If the flame alarm is frequently triggered when processing a certain material even though no actual fire occurs, you may adjust the flame detection sensitivity appropriately.<br/>
Note:<br/>
* If the sensitivity settings are changed, they should be restored to the original values when switching to different materials.<br/>
* The machine must still be supervised during operation after modifying these settings.<br/>
Adjustment commands:<br/>
$fire_alarm/overflow_value=10<br/>
Adjusts the number of trigger events required after exceeding the threshold.<br/>
(Usually does not need to be modified.)<br/>
$fire_alarm/threshold_value=97<br/>
Adjusts the flame detection threshold.<br/>
The higher the value, the more difficult it is to trigger the flame alarm.<br/>
Only modify the number after the equals sign.<br/>
(5) If the above steps do not resolve the issue, please send the following to customer service:<br/>
* A video showing the issue<br/>
* The troubleshooting steps already performed<br/>
* A photo of the machine’s Serial Number (see Figure 75)<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_75.png:Figure 75]<br/>
For replacement instructions, please refer to the Master flame detection board replacement video.`,
          video_url: ['https://youtu.be/2rLI6SMSBxw'],
        },
        {
          Q: `Master Displays a Water Temperature Abnormality Alarm`,
          A: `Solution: Please refer to the Master water temperature abnormality troubleshooting guide.<br/>
(1) Check the water tank level:<br/>
Make sure the water level in the tank is not too low. If the water level is low, add the required cooling liquid.<br/>
(2) Check the working environment:<br/>
The recommended operating environment for the Master is 5°C–35°C.<br/>
* If the temperature is below 5°C, add non-corrosive antifreeze coolant. Please refer to the “Master Water Tank Refill and Replacement Guide” section for details.<br/>
* If the ambient temperature exceeds 35°C, use air conditioning to lower the room temperature.<br/>
Note:<br/>
* When the water temperature exceeds 35°C, the machine will issue a high-temperature warning.<br/>
* When the water temperature exceeds 40°C, the machine will enter alarm mode and automatically stop operating.<br/>
(3) Check the water temperature reading:<br/>
Use AtomStack Studio or the control screen to check whether the displayed water temperature is normal.<br/>
If the water temperature exceeds 35°C, stop the machine and allow it to rest for 10 minutes. Also check whether the working environment temperature is too high.<br/>
(4) Check the temperature sensor:<br/>
If the ambient temperature is normal, the water level is normal, and the machine still reports a water temperature abnormality shortly after startup, check whether the water tank temperature sensor cable is loose (TEMP connector, see Figure 76).<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_76.png:Figure 76]<br/>
If the cable connection is secure, the temperature sensor may be faulty.<br/>
Please refer to the Master temperature sensor replacement video for replacement instructions.`,
          video_url: ['https://youtu.be/TFMc46qfYag','https://youtu.be/o2Sdz4srtv0'],
        },
        {
          Q: `Master’s Door-opening Detection Function Fails and the Machine Does Not Stop When the Enclosure Door Is Opened During Operation`,
          A: `Solution: Please refer to the Master door-opening detection troubleshooting guide.<br/>
(1) Confirm that the door detection function is enabled:<br/>
After connecting the machine, check whether the door detection function is enabled in either:<br/>
* the machine settings on the control screen, or<br/>
* the machine function settings in AtomStack Studio (see Figure 77).<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_77.png:Figure 77]<br/>
(2) Check the enclosure door limit switch:<br/>
◆ Hall sensor switch (please distinguish carefully):<br/>
Start an engraving task and open the enclosure door. If no alarm is triggered, the Hall sensor switch may be faulty.<br/>
Please send the following to customer service:<br/>
* A video showing the issue<br/>
* A photo of the machine’s Serial Number (see Figure 78)<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_78.png:Figure 78]<br/>
For replacement instructions, please refer to the Master limit switch replacement video.<br/>
Note:<br/>
Before receiving the replacement part, if continued operation is necessary, you may disable the door detection function in the software.<br/>
However, for safety reasons, do not open the enclosure door while the machine is operating.<br/>
◆ Enclosure door limit switch (please distinguish carefully):<br/>
Start an engraving task. After opening the enclosure door, manually press and release the limit switch lever to check whether the machine stops.<br/>
If the machine does not stop, the enclosure door limit switch may be faulty.<br/>
Please send the following to customer service:<br/>
* A video showing the issue<br/>
* A photo of the machine’s Serial Number<br/>
For replacement instructions, please refer to the Master limit switch replacement video.`,
          video_url: ['https://youtu.be/vrH8nX74p_w', 'https://youtu.be/VGDI8VWkCic'],
        },
        {
          Q: `After Using the Rotary Attachment with Master, the Engraved Output Appears Mirrored`,
          A: `Solution: Please refer to the troubleshooting guide for mirrored engraving output when using the rotary attachment with Master.<br/>
(1) Check whether mirror mode is enabled:<br/>
In the rotary settings of AtomStack Studio or LightBurn, check whether the “Mirror Output” option is enabled (see Figure 79 and Figure 80).<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_79.png:Figure 79]<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_80.png:Figure 80]<br/>
(2) Check the rotary attachment orientation:<br/>
The motor side of the rotary attachment must face the right side.<br/>
(3) Check the A-axis reverse direction setting:<br/>
In LightBurn or LaserGRBL:<br/>
* Open the **Edit** menu<br/>
* Select **Machine Settings**<br/>
* Find **“A Direction Pin Invert ($3)”**<br/>
If the setting is currently **True**, change it to **False**.<br/>
If it is currently **False**, change it to **True**.<br/>
Then click **Write**, followed by **OK** to save the settings (see Figure 81).<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_81.png:Figure 81]`,
          video_url: ['https://youtu.be/3mvA09cRmB4'],
        },
        {
          Q: `After Using the Rotary Attachment with Master, the Engraved Output Appears Distorted`,
          A: `Solution: Please refer to the troubleshooting guide for distorted engraving output when using the rotary attachment with Master.<br/>
(1) Check the software parameter settings:<br/>
Verify that the rotary attachment parameters in the control software are set correctly.<br/>
Please refer to the “Master Rotary Attachment Usage” section for the correct settings.<br/>
(2) Check the placement of the rotary attachment:<br/>
Make sure the rotary attachment is positioned parallel to the X-axis.<br/>
(3) Check the rotary attachment operating condition:<br/>
Carefully observe whether the material rotates abnormally while the rotary attachment is operating.<br/>
Also check whether there is oil or residue on the material surface that could reduce friction and cause slipping.<br/>
Note:<br/>
If using the R8 chuck rotary attachment, make sure the engraving surface is level after the material is clamped.`,
          video_url: ['https://youtu.be/__QEdX0cMSw'],
        },
        {
          Q: `Master Cannot Detect the Rotary Attachment`,
          A: `Solution:<br/>
(1) Check the USB cable connection:<br/>
The rotary attachment must be connected using the supplied USB cable (see Figure 82).<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_82.png:Figure 82]<br/>
(2) Check the USB connector on the mainboard:<br/>
Open the internal shield panel and check whether the USB connector on the mainboard is loose.<br/>
(3) If the above steps do not resolve the issue, try replacing the rotary auto-detection board and the expansion interface adapter board.<br/>
For replacement instructions, please refer to:<br/>
* the R6/R8 auto-detection board replacement video<br/>
* the Master expansion interface adapter board replacement video`,
          video_url: ['https://youtu.be/3Ec0IbOREY0','https://youtu.be/22X5vUsuOW0'],
        },
        {
          Q: `Master Cannot Detect the USB Drive`,
          A: `Solution: Please refer to the Master USB drive detection troubleshooting guide.<br/>
(1) Remove and reinsert the USB drive, then restart the machine to check whether the USB drive can be detected.<br/>
(2) Insert the USB drive into a computer and check whether it can be read normally.<br/>
(3) Format the USB drive on a computer using the FAT32 file system.<br/>
(4) Try using another USB drive with a capacity of 32 GB or less and check whether the machine can detect it automatically.<br/>
(5) If the above steps do not resolve the issue, please send the following to customer service:<br/>
* A video showing the issue<br/>
* The troubleshooting steps already performed<br/>
* A photo of the machine’s Serial Number (see Figure 83)<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_83.png:Figure 83]`,
          video_url: ['https://youtu.be/WUOIteKrtms'],
        },
        {
          Q: `Master Cannot Upgrade the Firmware`,
          A: `Solution: Please refer to the Master firmware upgrade troubleshooting guide.<br/>
(1) Confirm the firmware version:<br/>
Check the machine’s current firmware version in AtomStack Studio or the mobile app.<br/>
If the firmware name does not match the upgrade package, the firmware cannot be upgraded.<br/>
(2) Confirm that a USB drive is inserted:<br/>
A USB drive must be inserted into the machine during the firmware upgrade process, as it is used as the storage device.<br/>
(3) Confirm the firmware file format:<br/>
The firmware file must be in **.bin** format and must be placed in the root directory of the USB drive.<br/>
If you are upgrading by copying the firmware file to the USB drive manually, please make sure the file is not placed inside any folder.<br/>
(4) Confirm that the USB drive is functioning properly:<br/>
Insert the USB drive into a computer and check whether it can be read normally.<br/>
You can also export an NC or GC file from the software, copy it to the USB drive, insert the USB drive into the machine, and check on the control screen whether the file can be read correctly.`,
          video_url: ['https://youtu.be/kUMOodCElFc'],
        },
        {
          Q: `Master Still Displays “Tray Not Inserted” After the Tray Has Been Installed`,
          A: `Solution:<br/>
(1) Check whether the drawer Hall sensor switch is functioning properly:<br/>
Place a magnet near the Hall sensor switch located at the front-left bottom area of the machine (see Figure 84) and check whether the alarm is cleared.<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_84.png:Figure 84]<br/>
(2) Check the drawer Hall sensor wiring:<br/>
Open the machine enclosure and check whether the Hall sensor cable is connected properly.<br/>
If the cable connection is secure, the Hall sensor switch may be faulty.<br/>
Please send the following to customer service:<br/>
* A video showing the issue<br/>
* The troubleshooting steps already performed<br/>
* A photo of the machine’s Serial Number (see Figure 85)<br/>
For replacement instructions, please refer to the Master limit switch replacement video.<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_85.png:Figure 85]`,
          video_url: [],
        },
        {
          Q: `Master Timing Belt Is Broken`,
          A: `Solution: Please refer to the Master timing belt replacement video.<br/>
Note:<br/>
* Replacing the Y-axis timing belt requires removing the outer cover.<br/>
* When replacing the X-axis timing belt, loosen the timing belt tensioner first.`,
          video_url: ['https://youtu.be/kUMOodCElFc'],
        },
        {
          Q: `After Installing the 1.6W IR Laser Module on Master, the Software Cannot Detect It`,
          A: `Refer to the troubleshooting video: Master control software does not recognize the infrared laser.<br/>
(1) Confirm that the IR laser module is installed correctly:<br/>
There is a dedicated limit switch on the Z-axis designed for the IR laser module. The corresponding function will only be triggered when the IR laser module is installed correctly.<br/>
(2) Check the flame detection board wiring:<br/>
Disconnect and reconnect the flame detection board cable, then manually press the limit switch to check whether it can be detected by the software (see Figure 86).<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_86.png:Figure 86]<br/>
(3) Check the adapter board wiring:<br/>
Open the cover at the top of the Z-axis and check whether any cables on the adapter board are loose.<br/>
Disconnect and reconnect the cables, then test again (see Figure 87).<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_87.png:Figure 87]<br/>
(4) If the above steps do not resolve the issue, please send the following to customer service:<br/>
* A video showing the issue<br/>
* The troubleshooting steps already performed<br/>
* A photo of the machine’s Serial Number (see Figure 88)<br/>
[img:https://cdn.shopify.com/s/files/1/0677/4646/4064/files/master-figure_88.png:Figure 88]<br/>
For replacement instructions, please refer to:<br/>
* the Master adapter board replacement guide<br/>
* the Master flame detection board replacement guide`,
          video_url: ['https://youtu.be/Kxuy-XoRIRM'],
        },
        {
          Q: `Potential alarm codes for the Master control system`,
          A: `[table:master_part4_q34_table1]`,
          tables: {
            master_part4_q34_table1: {
              headers: [
                `Code`,
                `Description`,
                `	Solution`,
              ],
              rows: [
                [`ALARM:1`, `HardLimit`, `Observe whether the X-axis, Y-axis, or Z-axis limit switches are being triggered due to physical contact.`],
                [`ALARM:3`, `AbortCycle`, `This code is triggered when the engraving process is manually stopped and does not require clearing.`],
                [`ALARM:5`, `ProbeFailContact`, `Check whether the Z-axis limit switch has been triggered.`],
                [`ALARM:8`, `HomingFailPulloff`, `Homing failed due to limit switch reset failure. Check whether the machine stopped because a limit switch was triggered and whether the motion system is continuously triggering the limit switch.`],
                [`ALARM:9`, `HomingFailApproach`, `Please refer to the “Master Homing Failure” section.`],
                [`ALARM:11`, `MachineTiltAlarm`, `Tilt alarm detected. Place the machine back on a level surface and restart it. If the issue cannot be cleared, please send a video showing the problem and a photo of the machine’s Serial Number to customer service.`],
                [`ALARM:12`, `FlameDetected`, `Flame detection has been triggered. Restart the machine. If the alarm continues to trigger, please refer to the section “The Master Flame Detection Function Triggers False Alarms When No Fire Is Present” for troubleshooting.`],
                [`ALARM:13`, `DoorOpen`, `Enclosure open alarm detected. Please close the enclosure door. If the alarm still appears, check whether the limit switch is damaged.`],
              ],
            },
          },
          video_url: [],
        },
        {
          Q: `Replacing the Master Limit Switch`,
          A: `Solution: Please refer to the video.`,
          video_url: ['https://youtu.be/VEhqsnnPMnU'],
        },
        {
          Q: `Replacing the Water Pump`,
          A: `Solution: Please refer to the video.`,
          video_url: ['https://youtu.be/zpuPFeRqGgM'],
        },
        {
          Q: `Replacing the Air Pump`,
          A: `Solution: Please refer to the video.`,
          video_url: ['https://youtu.be/TfsoipPGjM0'],
        },
        {
          Q: `Replacing the Z-Axis Adapter Board`,
          A: `Solution: Please refer to the video.`,
          video_url: ['https://youtu.be/FjaU7-90SlQ'],
        },
      ],
    ],
  },
};
